import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Nav from "@/components/landing/Nav";
import Footer from "@/components/landing/Footer";

export default function LegalLayout({ title, effectiveDate, intro, children }) {
    return (
        <main className="relative overflow-x-clip bg-white">
            <Nav />

            <section className="pt-32 md:pt-40 pb-16 md:pb-20 bg-white">
                <div className="container-page max-w-3xl">
                    <Link
                        to="/"
                        data-testid="legal-back-home"
                        className="inline-flex items-center gap-1.5 text-sm text-gray-500 hover:text-[#0A0A0A] transition-colors"
                    >
                        <ArrowLeft className="h-4 w-4" />
                        Back to home
                    </Link>
                    <p className="mt-8 text-xs font-bold tracking-[0.2em] uppercase text-gray-500">
                        Legal
                    </p>
                    <h1
                        data-testid="legal-page-heading"
                        className="mt-4 font-display font-extrabold text-[40px] leading-[1.04] sm:text-5xl md:text-6xl lg:text-[64px] lg:leading-[1.02] tracking-[-0.03em] text-balance"
                    >
                        {title}
                    </h1>
                    <div className="mt-5 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-gray-500">
                        <span data-testid="legal-effective-date">
                            Effective Date:{" "}
                            <span className="text-[#0A0A0A] font-semibold">
                                {effectiveDate}
                            </span>
                        </span>
                        <span>AV Consultation</span>
                    </div>
                    {intro && (
                        <p className="mt-8 text-lg text-gray-600 leading-relaxed text-pretty">
                            {intro}
                        </p>
                    )}
                </div>
            </section>

            <section className="pb-24 md:pb-32 bg-white">
                <div className="container-page max-w-3xl">
                    <article
                        data-testid="legal-content"
                        className="prose-legal"
                    >
                        {children}
                    </article>

                    <div className="mt-16 pt-10 border-t border-black/5">
                        <p className="text-sm text-gray-500">
                            By using our website or services, you agree to
                            these terms.
                        </p>
                        <Link
                            to="/"
                            data-testid="legal-back-home-bottom"
                            className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-[#0A0A0A] hover:text-[#059669] transition-colors"
                        >
                            <ArrowLeft className="h-4 w-4" />
                            Back to home
                        </Link>
                    </div>
                </div>
            </section>

            <Footer />
        </main>
    );
}

export const Section = ({ number, title, children, testId }) => (
    <section
        data-testid={testId}
        className="mt-12 md:mt-14 first:mt-10 scroll-mt-28"
    >
        <div className="flex items-baseline gap-4">
            {number != null && (
                <span className="font-display font-bold text-sm text-[#059669] tracking-tight tabular-nums">
                    {String(number).padStart(2, "0")}
                </span>
            )}
            <h2 className="font-display font-bold text-2xl md:text-[28px] tracking-[-0.02em] text-[#0A0A0A]">
                {title}
            </h2>
        </div>
        <div className="mt-5 space-y-4 text-[16px] leading-[1.75] text-gray-700 [&_p]:text-pretty">
            {children}
        </div>
    </section>
);

export const SubTitle = ({ children }) => (
    <p className="mt-4 font-display font-semibold text-[#0A0A0A] text-[17px] tracking-tight">
        {children}
    </p>
);

export const List = ({ items }) => (
    <ul className="mt-2 space-y-2.5">
        {items.map((it, i) => (
            <li key={i} className="flex gap-3 text-[16px] leading-[1.7]">
                <span className="flex-none mt-[10px] h-[6px] w-[6px] rounded-full bg-[#059669]" />
                <span>{it}</span>
            </li>
        ))}
    </ul>
);
